import { render, staticRenderFns } from "./Flashed.vue?vue&type=template&id=4fc33253&"
import script from "./Flashed.vue?vue&type=script&lang=js&"
export * from "./Flashed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports